import { TableHead, Table, Grid, Typography } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const StyledTable = styled(Table)(({ theme }) => ({
  borderCollapse: "separate",
  "& .MuiTableBody-root": {
    "& .MuiTableCell-root": {
      padding: "8px",
      // position : "relative"
    },
    "& .MuiTableRow-root": {
      "& .MuiTableCell-root:not(:last-of-type)": {
        borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.6)}`,
      },
    },
  },
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  position: "sticky",
  top: 0,
  "& .MuiTableCell-root": {
    padding: "3px 10px",
  },
  "& .MuiTableRow-root": {
    "&:first-of-type": {
      "& .MuiTableCell-root": {
        // borderBottom : `1px solid ${lightentheme.palette.secondary.light}`,
        backgroundColor: theme.palette.background.paper,
        "&:first-of-type": {
          borderRadius: "8px 0px 0px 0px",
          // width: "25%",
        },
        "&:last-of-type": {
          borderRadius: "0px 8px 0px 0px",
        },
        "& .MuiTypography-root": {
          fontWeight: 500,
        },
        "&:not(:last-of-type)": {
          borderBottom: "none",
          borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.6)}`,
        },
      },
    },

    "&:last-of-type": {
      "& .MuiTableCell-root": {
        backgroundColor: theme.palette.background.paper,

        "&:first-of-type": {
          borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.6)}`,
        },
        "&:last-of-type": {
          borderRadius: "0px 0px 8px 0px",
        },
        "& .MuiTypography-root": {
          fontWeight: 500,
        },
      },
    },
  },
}));

export const ApproversContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "7px",
  "& a": {
    textDecoration: "unset",
  },
}));

export const ApproverAddress = styled(Typography)(({ theme }) => ({
  color: "rgb(80 115 162)",
  lineHeight: 1.4,
  cursor: "pointer !important",
}));

export const EmployeeNameBlock = styled(Grid)(({ theme }) => ({
  "&:hover, &:hover .MuiTypography-root": {
    cursor: "pointer",
  },
}));
